import { useCallback } from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRReachableComponentIcon from '../../../NRIcons/NRReachableComponentIcon';
import NRValueTooltipIcon from '../../NRReactGridCustomComponents/NRCustomProviders/NRValueTooltipIcon';
import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../../../constants/constants';

export function NRReachableComponentIconProvider({ reachableIconColor, ...dataTypeProviderProps }) {
  const Formatter = useCallback(
    function ReachableComponentIconFormatter({ value, column, row }) {
      const { isReachable } = row;
      const theme = useTheme();
      const color = reachableIconColor ?? theme.palette.warning.main;
      return (
        <NRValueTooltipIcon
          value={value}
          icon={isReachable ? <NRReachableComponentIcon width={20} height={20} color={color} /> : null}
          tooltip={isReachable ? CONSTANTS.VULNERABILITIES.REACHABLE_TOOLTIP : null}
        />
      );
    },
    [reachableIconColor]
  );

  return <DataTypeProvider formatterComponent={Formatter} {...dataTypeProviderProps} />;
}
